<div class="d-flex h-100 text-center">
    <div class="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
        <app-navigation/>

        <main class="px-3">
            <div class="hero-section mb-5">
                <div class="qr-code-container text-center mb-4">
                    <i class="fas fa-qrcode qr-code-icon"></i>
                </div>
                <h1 class="display-4 fw-bold mb-4">Digitale Anleitungen leicht gemacht</h1>
                <p class="lead fs-4">
                    <span class="highlight">ManualRadar</span> revolutioniert den Zugriff auf Handbücher und Betriebsanleitungen.
                    Mit einem einfachen QR-Code-Scan haben Sie sofort alle wichtigen Informationen zur Hand.
                </p>
                <div class="benefits mt-4 d-flex justify-content-center">
                    <div class="benefit-item mx-3">
                        <i class="fas fa-bolt text-warning fs-3"></i>
                        <p>Blitzschnell</p>
                    </div>
                    <div class="benefit-item mx-3">
                        <i class="fas fa-shield-alt text-warning fs-3"></i>
                        <p>Sicher</p>
                    </div>
                    <div class="benefit-item mx-3">
                        <i class="fas fa-clock text-warning fs-3"></i>
                        <p>Jederzeit verfügbar</p>
                    </div>
                </div>
            </div>
            <div class="lead d-flex justify-content-center gap-3">
                <a class="btn btn-lg btn-warning fw-bold border-white shadow-sm" [routerLink]="['/demo']">
                    <i class="fas fa-play-circle me-2"></i>Demo ausprobieren
                </a>
                <a class="btn btn-lg btn-warning fw-bold border-white shadow-sm" [routerLink]="['/features']">
                    <i class="fas fa-arrow-circle-right me-2"></i>Mehr erfahren
                </a>
            </div>
        </main>

        <footer class="mt-auto">
            <p>Ein Produkt der <a href="https://www.noteradar.at/" class="text-black fw-bold" target="_blank">NoteRadar GmbH</a></p>
        </footer>
    </div>
</div>
